import { PropsWithChildren } from "react";

import { useReservationProjectRequest } from "@/features/pro-buyer-projects/hooks/useReservationProjectRequest";
import { ReservationMutationResult } from "@/features/pro-buyer-reservations/data/reservations-client";
import { Button } from "@/ui/cva/Button";

type ReservationRequestSendButtonProps = {
  productId: string;
  /** WHO-5959 6e: the chosen project, or null for the step 4 request without one. */
  projectId: string | null;
  loading: boolean;
  run: (send: () => Promise<ReservationMutationResult>) => void;
  requestWithoutProject: () => Promise<ReservationMutationResult>;
};

/**
 * WHO-5959 6e. "Send request" in the reservation modal. Lives in its own
 * component so the Apollo mutation for a project is only mounted while the
 * request modal is open, never on every product page.
 */
export const ReservationRequestSendButton = ({
  productId,
  projectId,
  loading,
  run,
  requestWithoutProject,
  children,
}: PropsWithChildren<ReservationRequestSendButtonProps>) => {
  const requestForProject = useReservationProjectRequest();

  return (
    <Button
      type="button"
      className="w-full sm:w-auto"
      loading={loading}
      onClick={() =>
        run(() =>
          projectId
            ? requestForProject(productId, projectId)
            : requestWithoutProject()
        )
      }
    >
      {children}
    </Button>
  );
};
